
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin-portal/onboarding/contact-us",
      function () {
        return require("private-next-pages/admin-portal/onboarding/contact-us.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin-portal/onboarding/contact-us"])
      });
    }
  